
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_425_134)"}},[_c('path',{attrs:{"d":"M11.47 13.483l-.126-.166c-.67-.876-1.457-1.618-2.454-2.11-.657-.321-1.34-.527-2.082-.428-.604.08-1.068.37-1.287.97-.135.37-.112.755-.05 1.14.018.111.063.17.175.191.107.023.214.068.317.103 1.046.38 1.926 1.02 2.744 1.757.85.764 1.618 1.618 2.342 2.507.009.009.013.018.022.027.586.72 1.739.491 2.012-.394.062-.205.12-.393.17-.55.737-2.36 1.568-4.688 2.694-6.895a26.402 26.402 0 013.115-4.796A29.02 29.02 0 0123.496.51c-.005-.01 0 .004 0-.005-5.935 2.53-9.926 6.865-12.027 12.983v-.004z","fill":"#000"}}),_c('path',{attrs:{"d":"M18.942 24a1.4 1.4 0 01-1.4-1.399v-2.257h-2.256c-.774 0-1.4-.63-1.4-1.399 0-.768.63-1.398 1.4-1.398h2.257v-2.258c0-.773.63-1.398 1.399-1.398.768 0 1.398.63 1.398 1.399v2.257h2.257c.773 0 1.4.63 1.4 1.398 0 .77-.631 1.4-1.4 1.4H20.34V22.6a1.4 1.4 0 01-1.398 1.4zM22.858 13.48a1.14 1.14 0 01-1.14-1.135V6.901a1.139 1.139 0 112.28 0v5.44c0 .63-.51 1.14-1.14 1.14z","fill":"#010101"}}),_c('path',{attrs:{"d":"M16.085 0H5.565A5.568 5.568 0 000 5.564v12.872A5.57 5.57 0 005.564 24H12.892a1.139 1.139 0 00.348-2.221.73.73 0 00-.25-.063H5.56a3.29 3.29 0 01-3.285-3.285V5.564A3.29 3.29 0 015.56 2.28h10.52a1.139 1.139 0 100-2.279h.005z","fill":"#010101"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_425_134"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    